export const computeFreeDeliveryInfos = (
  totalCartPrice: number,
  freeDeliveryThreshold: number,
): {
  hasReachedFreeDelivery: boolean;
  amountUntilFreeDeliveryInCents: number;
  freeDeliveryProgression: number;
} => {
  const hasReachedFreeDelivery = totalCartPrice >= freeDeliveryThreshold;
  const amountUntilFreeDelivery = Math.max(
    0,
    freeDeliveryThreshold - totalCartPrice,
  );
  const freeDeliveryProgression = hasReachedFreeDelivery
    ? 100
    : (totalCartPrice / freeDeliveryThreshold) * 100;

  const amountUntilFreeDeliveryInCents = amountUntilFreeDelivery * 100;

  return {
    hasReachedFreeDelivery,
    amountUntilFreeDeliveryInCents,
    freeDeliveryProgression,
  };
};
